export default {
  title: 'Gateway di pagamento',
  fields: {
    name: 'Nome',
    payment_gateway: 'Gateway di pagamento',
    live_from: 'Attivo dal',
    last_30_days_sales: 'Vendite ultimi 30 giorni',
    kyc_deadlines: 'Scadenze KYC',
    actions: 'Azioni',
  },
  stats: {
    active_on_stripe: 'Attivo su Stripe',
    active_on_adyen: 'Attivo su Adyen',
    adyen_verification_pending: 'Verifica Adyen in attesa',
  },
  filters: {
    search_placeholder: 'Cerca per nome...',
    gateway_status_placeholder: 'Tutti i gateway',
  },
  not_configured: {
    title: 'I pagamenti non sono ancora configurati',
    description:
      'Nessun provider di pagamento è collegato al tuo account. I ristoranti possono essere configurati, ma non possono andare online o accettare pagamenti finché i pagamenti non vengono configurati.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (In attesa)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Verificato',
    pending: 'In attesa',
    rejected: 'Rifiutato',
  },
  buttons: {
    actions: 'Azioni',
    switch_to: 'Passa a {{gateway}}',
    view_details: 'Visualizza dettagli',
    open_onboarding: 'Apri onboarding',
    create_onboarding_link: 'Crea link di onboarding',
  },
  modal: {
    title: 'Cambia gateway di pagamento',
    description:
      'Vuoi davvero passare {{companyName}} da <bold>{{currentGateway}}</bold> a <bold>{{targetGateway}}</bold>?',
    not_verified_warning:
      "{{gateway}} non è verificato per questa azienda. L'elaborazione dei pagamenti potrebbe essere compromessa.",
    confirm: 'Cambia',
    cancel: 'Annulla',
  },
  details_modal: {
    title: '{{companyName}} — Dettagli gateway di pagamento',
    requirements: 'Requisiti',
    no_requirements: 'Nessun requisito in sospeso.',
    deadline: 'Scadenza',
    capabilities: 'Funzionalità',
    onboarding_links: {
      section_title: 'Link di onboarding',
      active_link: 'Link attivo',
      expires: 'Scade {{date}}',
      create_button: 'Crea link',
      extend_button: 'Estendi link',
      loading: 'Caricamento link…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Impossibile creare il link di onboarding.',
    switch_success: 'Gateway di pagamento cambiato con successo.',
    switch_failed: 'Impossibile cambiare il gateway di pagamento.',
    failed_to_load_data: 'Impossibile caricare i dati.',
  },
};
